"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconFullscreen = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var IconFullscreen = function IconFullscreen(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.07 13.213l-5.834 5.77v-3.728h-1.21v5.77H8.86v-1.196H5.09l5.835-5.77zm5.573-9.229h3.769l-5.834 5.77.855.846 5.834-5.77v3.728h1.21v-5.77h-5.834z",
    fillRule: "evenodd"
  }));
};
exports.IconFullscreen = IconFullscreen;